/**
 *  FIX:  Cannot redeclare block-scoped variable 'commonGlobal'.
 * 进行测试命令行时，lib下的d.ts文件与本文件的commonGlobal 定义冲突，利用typescript 模块化解决，添加默认export关键字，就会被typescript任务这个文件是一个模块，不会与全局变量冲突。
 * 具体解释如下
 * https://www.jianshu.com/p/78268bd9af0a
 */

const ssrGlobal = typeof window === 'undefined' ? {
    addEventListener: () => {},
    removeEventListener: () => {},
    setTimeout: () => {},
    setInterval: () => {},
    _WEBLOGGER_MOCKED_WINDOW_: true,
    document: {
        cookie: '',
        addEventListener: () => {},
        removeEventListener: () => {},
        querySelector: () => {},
        querySelectorAll: () => {},
    },
    navigator: {
        userAgent: '',
        sendBeacon: function() {},
    },
    screen: {},
    history: {},
    location: {
        hostname: '',
        search: '',
        href: '',
        origin: ''
    },
    localStorage: {
        getItem: () => {},
        setItem: () => {}
    },
} : window;



export default ssrGlobal as Window & typeof globalThis & { __yodaBridge__: any };
